import dayjs from "dayjs";

export const formattedDateVigency = (dates: any, formatDate: string = "DD-MM-YYYY") => {
    const formattedDates = dates?.map(
      (date: string | number | Date | dayjs.Dayjs | null | undefined) =>
        dayjs(date)?.format(formatDate)
    );
    const startDate = formattedDates[0];
    const endDate = formattedDates[1];

    return {
      startDate,
      endDate,
    };
  };